import { useMemo } from 'react';

import { useFeature } from 'src/app/FeatureToggle/useFeature';
import useCredentialsExpiringSoonCount from 'src/common/credentials/useCredentialsExpringSoonCount';
import type { NavItem } from 'src/common/NavBar/TopLevelNavItemContext';

export function useFleetNavItems(navItems: NavItem[]) {
  const { isEnabled, isLoading } = useFeature('vehicle credentials');

  const expiredMemberCredentialsCount = useCredentialsExpiringSoonCount();

  const tabs = useMemo(() => {
    const credentialsTabExists = navItems.some(
      (tab) => tab.name === 'Credentials'
    );

    if (!isLoading && isEnabled && !credentialsTabExists) {
      return [
        ...navItems,
        {
          name: 'Credentials',
          href: '/fleet/credentials',
          badgeCount: expiredMemberCredentialsCount?.vehicle,
        },
      ];
    }

    return navItems;
  }, [navItems, isEnabled, isLoading, expiredMemberCredentialsCount]);

  return tabs;
}
